// extracted by mini-css-extract-plugin
export default {"filters_tabs":"OurVideos_filters_tabs__I9kut","gallery_show":"OurVideos_gallery_show__N1-r7"};